import { BUYER_ANALYTICS_EVENTS } from "../../constants/automapAnalyticsEvents";
import { trackBuyerEvent } from "../buyerAnalytics";

export function trackBuyerPreferencesViewed(slug, extra = {}) {
  trackBuyerEvent(BUYER_ANALYTICS_EVENTS.BUYER_PREFERENCES_VIEWED, {
    clientViewSlug: slug,
    sourcePage: "buyer_account",
    sourceComponent: "buyer_preferences",
    ...extra,
  });
}

export function trackBuyerFinancingPrefsSaved(slug, financingPrefs = {}, extra = {}) {
  trackBuyerEvent(BUYER_ANALYTICS_EVENTS.BUYER_FINANCING_PREFS_SAVED, {
    clientViewSlug: slug,
    hasFinancingPrefs: true,
    termMonths: financingPrefs.termMonths ?? null,
    ...extra,
  });
}

export function trackBuyerQuizIntentSaved(slug, extra = {}) {
  trackBuyerEvent(BUYER_ANALYTICS_EVENTS.BUYER_QUIZ_INTENT_SAVED, {
    clientViewSlug: slug,
    hasQuizIntent: true,
    ...extra,
  });
}

export function trackBuyerProfileMergeApplied(slug, merged = {}, extra = {}) {
  trackBuyerEvent(BUYER_ANALYTICS_EVENTS.BUYER_PROFILE_MERGE_APPLIED, {
    clientViewSlug: slug,
    quizIntentMerged: Boolean(merged.quizIntent),
    financingPrefsMerged: Boolean(merged.financingPrefs),
    ...extra,
  });
}
